import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import './VideoDetails.css';
import './Offerings.css';

function VideoDetails(props) {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { videoTitle, videoUrl, videoResourceUrl } = props;

    const cloudFrontBaseVideoURL = 'https://resources.mrreedsteamlab.com/steam-lab-videos/';

    const cloudFrontBaseResourcesURL = 'https://resources.mrreedsteamlab.com/steam-lab-resources/';

    return (
        <div className="video-details__outer-container">
            <div className="video-details__inner-container">
                <div className="video-details__title">{videoTitle}</div>
                <div className="video-details__video">
                    {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                    <video
                        className="video-mask"
                        playsInline
                        controls
                        controlsList="nodownload"
                        style={{ opacity: 1, width: '100%' }}>
                        <source
                            src={cloudFrontBaseVideoURL + videoUrl}
                            type="video/mp4" />
                    </video>
                </div>
                {/* technology videos have no additional resources; don't render this */}
                {videoResourceUrl ? (
                    <div className="video-details__resources">
                        <div className="video-details__resources-text">
                            Additional Resources & Enrichment:
                            <div className="video-details__resources-file">
                                <a
                                    href={
                                        cloudFrontBaseResourcesURL
                                        + videoResourceUrl
                                    }
                                    target="_blank"
                                    rel="noreferrer">
                                    <FontAwesomeIcon
                                        icon={faFilePdf}
                                        color="black"
                                        size="1x" />
                                    <span className="video-details__resources-file-text">
                                        {videoTitle}
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default VideoDetails;
